// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gateway-report .history .history-param {
  position: absolute;
  top: -130px;
  left: -2px;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.gateway-report .downloads {
  margin-left: 55px;
  border: none;
  padding: 0;
  background: transparent;
}

.gateway-report .downloads img {
  height: 46px;
}

.gateway-report .date-filter {
  display: flex;
  align-items: center;
}

.gateway-report .custom-select {
  width: 120px;
}

.gateway-report .date-filter p {
  margin-bottom: 0;
  margin-right: 5px;
  font-size: 10px;
}

.gateway-report .summary-card {
  padding: 10px;
  border-radius: 10px;
  color: #000000;
}

.gateway-report .total-card {
  background-color: #d8d8d8;
}

.gateway-report .success-card {
  background-color: #ecfdee;
}

.gateway-report .failed-card {
  background-color: #ffefe0;
}

.gateway-report .total-label {
  font-size: 14px;
  text-transform: uppercase;
  opacity: 1;
  /* padding-top: 30px; */
  margin-bottom: 5px;
}

.gateway-report .total-value {
  font-size: 18px;
}

.gateway-report .total-value span {
  font-weight: 600;
}

.gateway-report .count-label {
  font-size: 14px;
  text-transform: uppercase;
  color: #9b9b9b;
  margin-top: 15px;
  margin-bottom: 5px;
}

.gateway-report .filter-btn {
  background-color: transparent;
  color: #060d27;
  border: 1px solid #060d27;
  height: 44px;
  padding-inline: 20px;
  margin-left: auto;
}

.gateway-report .history {
  margin-top: 130px;
}

.gateway-report .gateway-compliance {
  background-color: #ffffff;
  padding: 10px;
  margin-top: 60px;
}

.gateway-report .gateway-config .content {
  background-color: #ffffff;
  padding: 10px;
}

.gateway-report .risk-profile-modal h4 {
  font-size: 22px;
  text-align: left;
  color: #000000;
}

.gateway-report .risk-profile-modal .form-control {
  border: none;
  background-color: transparent;
}

.gateway-report .risk-profile-modal .form-control:focus {
  outline: none;
  box-shadow: none;
}

.gateway-report .modal label {
  text-align: left;
}

.gateway-report .modal .grouped-input {
  width: 350px;
}

.gateway-report .risk-profile-modal .update-btn {
  color: #ffffff;
  border: none;
  background-color: #4541d1;
  padding: 8px;
  border-radius: 4px;
}

.gateway-report .risk-profile-modal .band-name {
  text-align: left;
}

.gateway-report .risk-config .btn {
  border: none;
  background-color: transparent;
  padding-right: 8px;
  color: #4541d1;
  padding: 0 5px;
  height: unset;
}

.gateway-report .risk-config .delete-btn {
  color: red;
}

.gateway-report .add-config {
  margin-bottom: 20px;
  display: flex;
}

.gateway-report .add-config .add-config-btn {
  border: none;
  background-color: #4541d1;
  color: #ffffff;
  padding: 5px 10px;
  border-radius: 6px;
  margin-left: auto;
}

.gateway-report .switch-stat .custom-select {
  width: 100%;
}

.gateway-report .switch-stat .dropdown {
  border: 0.5px solid #327fec;
  padding: 10px;
}

.gateway-report .grouped-input small {
  font-size: 11px;
  float: right;
  margin-bottom: 10px;
  margin-top: 6px;
}

.gateway-report .charge-profile-modal .custom-select {
  width: 100%;
}

.gateway-report .charge-profile-modal .dropdown {
  border: 1px solid #327fec;
}

.gateway-report .gateway-settlement {
  margin-top: 65px;
}

.gateway-report .gateway-settlement .custom-select {
  width: 180px;
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/payment-gateway/GatewayReport.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".gateway-report .history .history-param {\n  position: absolute;\n  top: -130px;\n  left: -2px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.gateway-report .downloads {\n  margin-left: 55px;\n  border: none;\n  padding: 0;\n  background: transparent;\n}\n\n.gateway-report .downloads img {\n  height: 46px;\n}\n\n.gateway-report .date-filter {\n  display: flex;\n  align-items: center;\n}\n\n.gateway-report .custom-select {\n  width: 120px;\n}\n\n.gateway-report .date-filter p {\n  margin-bottom: 0;\n  margin-right: 5px;\n  font-size: 10px;\n}\n\n.gateway-report .summary-card {\n  padding: 10px;\n  border-radius: 10px;\n  color: #000000;\n}\n\n.gateway-report .total-card {\n  background-color: #d8d8d8;\n}\n\n.gateway-report .success-card {\n  background-color: #ecfdee;\n}\n\n.gateway-report .failed-card {\n  background-color: #ffefe0;\n}\n\n.gateway-report .total-label {\n  font-size: 14px;\n  text-transform: uppercase;\n  opacity: 1;\n  /* padding-top: 30px; */\n  margin-bottom: 5px;\n}\n\n.gateway-report .total-value {\n  font-size: 18px;\n}\n\n.gateway-report .total-value span {\n  font-weight: 600;\n}\n\n.gateway-report .count-label {\n  font-size: 14px;\n  text-transform: uppercase;\n  color: #9b9b9b;\n  margin-top: 15px;\n  margin-bottom: 5px;\n}\n\n.gateway-report .filter-btn {\n  background-color: transparent;\n  color: #060d27;\n  border: 1px solid #060d27;\n  height: 44px;\n  padding-inline: 20px;\n  margin-left: auto;\n}\n\n.gateway-report .history {\n  margin-top: 130px;\n}\n\n.gateway-report .gateway-compliance {\n  background-color: #ffffff;\n  padding: 10px;\n  margin-top: 60px;\n}\n\n.gateway-report .gateway-config .content {\n  background-color: #ffffff;\n  padding: 10px;\n}\n\n.gateway-report .risk-profile-modal h4 {\n  font-size: 22px;\n  text-align: left;\n  color: #000000;\n}\n\n.gateway-report .risk-profile-modal .form-control {\n  border: none;\n  background-color: transparent;\n}\n\n.gateway-report .risk-profile-modal .form-control:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.gateway-report .modal label {\n  text-align: left;\n}\n\n.gateway-report .modal .grouped-input {\n  width: 350px;\n}\n\n.gateway-report .risk-profile-modal .update-btn {\n  color: #ffffff;\n  border: none;\n  background-color: #4541d1;\n  padding: 8px;\n  border-radius: 4px;\n}\n\n.gateway-report .risk-profile-modal .band-name {\n  text-align: left;\n}\n\n.gateway-report .risk-config .btn {\n  border: none;\n  background-color: transparent;\n  padding-right: 8px;\n  color: #4541d1;\n  padding: 0 5px;\n  height: unset;\n}\n\n.gateway-report .risk-config .delete-btn {\n  color: red;\n}\n\n.gateway-report .add-config {\n  margin-bottom: 20px;\n  display: flex;\n}\n\n.gateway-report .add-config .add-config-btn {\n  border: none;\n  background-color: #4541d1;\n  color: #ffffff;\n  padding: 5px 10px;\n  border-radius: 6px;\n  margin-left: auto;\n}\n\n.gateway-report .switch-stat .custom-select {\n  width: 100%;\n}\n\n.gateway-report .switch-stat .dropdown {\n  border: 0.5px solid #327fec;\n  padding: 10px;\n}\n\n.gateway-report .grouped-input small {\n  font-size: 11px;\n  float: right;\n  margin-bottom: 10px;\n  margin-top: 6px;\n}\n\n.gateway-report .charge-profile-modal .custom-select {\n  width: 100%;\n}\n\n.gateway-report .charge-profile-modal .dropdown {\n  border: 1px solid #327fec;\n}\n\n.gateway-report .gateway-settlement {\n  margin-top: 65px;\n}\n\n.gateway-report .gateway-settlement .custom-select {\n  width: 180px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
